import { useEffect, useState } from 'react';
import log from 'chameleon/ui-stack/utilities/log';
import fetchFlags from 'legacy-src/utility/featureFlag/fetchFlags';
import { flagList } from 'legacy-src/reducers/featureFlag';
import get from 'lodash/get';
import omit from 'lodash/omit';

const useFetchFlags = ({ initId, setFeatureFlagAction, attributes = {} }) => {
  const [fetchedFlags, setFetchedFlags] = useState(null);
  const filteredFlags = { ...flagList };
  // this ff will be handled individually
  delete filteredFlags.show_maintenance_page;
  const flagsByKeys = Object.keys(filteredFlags);
  useEffect(() => {
    fetchFlags(flagsByKeys, initId, attributes)
      .then((treatments) => {
        /**
         * The omit prevents a race-condition with split where
         * A: masterSubjectId appears as empty initially
         * B: we bulk fetch the flag treatments
         * C: masterSubjectId is then correctly set from the withRouter HoC (from react-router)
         * D: We refetch the spp_filter_by_subject flag as a result of C
         *
         * If we get D back before B comes back, we eventually end up setting it
         * to OFF (incorrectly) because in B we fetched the spp_filter_by_subject flag
         * with an invalid masterSubjectId.
         *
         * By not setting the treatment until we have a valid masterSubjectId we ensure this
         * race-condition doesn't exist.
         */
        const masterSubjectId = get(attributes, 'masterSubjectId', null);
        let omitArray = [];
        if (!masterSubjectId) {
          omitArray = ['spp_filter_by_subject'];
        }
        const {
          payload: { flags },
        } = setFeatureFlagAction({
          ...omit(treatments, omitArray),
          areFeatureFlagsLoaded: 'on',
        });
        setFetchedFlags(flags);
      })
      .catch((error) => {
        log('error', error);
      });
  }, [initId]);

  useEffect(() => {
    /**
     * Don't bother refetching if the masterSubjectId
     * is not set.
     */
    if (!get(attributes, 'masterSubjectId', null)) return null;
    fetchFlags(['spp_filter_by_subject'], initId, attributes)
      .then((treatments) => {
        const {
          payload: { flags },
        } = setFeatureFlagAction({
          ...treatments,
        });
        setFetchedFlags(flags);
      })
      .catch((error) => {
        log('error', error);
      });
  }, [get(attributes, 'masterSubjectId', null)]);

  return [fetchedFlags];
};

export default useFetchFlags;
